<template>
  <div class="tab">
    <touch-header style="height: 100px;width: 100%;background-color: #008f47;" ></touch-header>
    <el-tabs v-model="activeName" style="margin: 0 auto;margin: 50px;padding: 0">
      <el-tab-pane label="最新新闻" name="first" :key="'first'">
        <news-list></news-list>
      </el-tab-pane>

      <el-tab-pane label="行业动态" name="second" :key="'second'">
        <industry-list></industry-list>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
// eslint-disable-next-line import/extensions,import/no-unresolved
import NewsList from './news/NewsList.vue';
// eslint-disable-next-line import/extensions,import/no-unresolved
import IndustryList from './Industry/IndustryList.vue';
// eslint-disable-next-line import/no-unresolved
import TouchHeader from '../components/TouchHeader.vue';

export default {
  name: 'tabs',
  components: {
    NewsList,
    IndustryList,
    TouchHeader,
  },
  data() {
    return {
      // 默认第一个选项卡
      activeName: 'first',
    };
  },
};
</script>

<style scoped>
  .tab{
    background-color: #F0F0F0;
  }

</style>
<style>
  .tab .el-tabs--border-card>.el-tabs__content{
    padding: 0;
  }
</style>
